import { AdminShell } from '@/features/admin/components/admin-shell.js';
import { useAuth } from '@/lib/auth/use-auth.js';
import { tokens } from '@/lib/tokens.js';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_admin/admin')({
  component: AdminIndexPage,
});

function AdminIndexPage() {
  const { user } = useAuth();

  return (
    <AdminShell currentPath="/admin">
      <div>
        <h1
          style={{
            fontSize: '1.5rem',
            fontWeight: 700,
            color: tokens.colors.textDark,
            marginBottom: '0.5rem',
          }}
        >
          Admin Panel
        </h1>
        <p style={{ color: tokens.colors.textMutedDark, marginBottom: '2rem' }}>
          Welcome, {user?.displayName ?? user?.email}. Use the sidebar to navigate.
        </p>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
            gap: '1rem',
          }}
        >
          {[
            {
              label: 'Templates',
              desc: 'Global template catalog',
              href: '/templates',
              superAdmin: true,
            },
            {
              label: 'Installations',
              desc: 'Tenant template installations',
              href: '/tenant-templates',
            },
            { label: 'Roles', desc: 'Manage roles and members', href: '/roles' },
            { label: 'Grants', desc: 'Permission matrix', href: '/grants' },
            { label: 'Audit Log', desc: 'Activity history', href: '/audit-log' },
          ]
            .filter((item) => !item.superAdmin || user?.isSuperAdmin)
            .map((item) => (
              <a
                key={item.href}
                href={item.href}
                style={{
                  backgroundColor: tokens.colors.bgCardDark,
                  border: `1px solid ${tokens.colors.borderDark}`,
                  borderRadius: tokens.radius.card,
                  padding: '1.25rem',
                  textDecoration: 'none',
                  display: 'block',
                  transition: 'all 0.2s ease',
                }}
              >
                <p
                  style={{
                    fontWeight: 600,
                    color: tokens.colors.textDark,
                    margin: '0 0 0.375rem',
                  }}
                >
                  {item.label}
                </p>
                <p style={{ fontSize: '0.875rem', color: tokens.colors.textMutedDark, margin: 0 }}>
                  {item.desc}
                </p>
              </a>
            ))}
        </div>
      </div>
    </AdminShell>
  );
}
